import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { Customer } from '../../models/Customer';
import { selectEmployeesOfCustomer } from '../../state/customer/customer.selector';
import { getCustomerEmployees } from '../../state/customer/customer.actions';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-manage-employees',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTableModule, PageHeaderComponent],
  templateUrl: './manage-employees.component.html',
  styleUrl: './manage-employees.component.css'
})
export class ManageEmployeesComponent implements OnInit {
  employees$: Observable<Customer[]>;

  constructor(private store: Store) {
    this.employees$ = this.store.select(selectEmployeesOfCustomer).pipe(
      map(employees => employees ?? [])
    );
  }

  ngOnInit(): void {
    this.store.dispatch(getCustomerEmployees());
  }
}
